import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import axios from "axios";
import { BaseURL } from "../../../../../Files/BaseURL";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ThemeContext from "../../../../../Context/theme/ThemeContext";

const AddDescription = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const [Product, setProduct] = useState(null);
  const [User, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const fetchProduct = async () => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/product/getproduct/${id}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );
      setProduct(response.data);
      setUser(response.data.User);
    } catch (error) {
      showAlert("Error fetching Product", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, []);

  return (
    <div className="w-[95%] m-auto flex flex-col lg:flex-row gap-6 py-6">
      <div
        className={`basis-2/3 border-2 border-light flex flex-col gap-4 rounded-2xl py-4 px-6 overflow-hidden ${
          theme == "dark" ? "bg-black text-white" : "bg-white"
        }`}
      >
        <div className="flex font-pop flex-row justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">{Product?.Title}</h2>
          <div className="bg-primarygreen/30 font-pop py-1 px-4 rounded-full h-fit font-medium text-xl">
            ${Product?.Price}
          </div>
        </div>

        <div className="w-full">
          <div className="relative">
            <Swiper
              navigation={true}
              modules={[Navigation]}
              className="product-gallery-swiper"
              onSwiper={(swiper) => setSwiperInstance(swiper)}
            >
              {Product?.Images?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="relative aspect-[4/3] w-full bg-gray-50 rounded-lg overflow-hidden">
                    <img
                      src={item.img}
                      alt={`Product image ${index + 1}`}
                      className="absolute inset-0 w-full h-full object-contain"
                      loading={index === 0 ? "eager" : "lazy"}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="flex gap-2 mt-4 px-1">
            {Product?.Images?.map((item, index) => (
              <div
                key={index}
                className={`relative w-20 aspect-[4/3] rounded-md overflow-hidden cursor-pointer 
                  ${
                    swiperInstance?.activeIndex === index
                      ? "ring-2 ring-primarygreen"
                      : "ring-1 ring-gray-200 hover:ring-primarygreen/50"
                  }`}
                onClick={() => swiperInstance?.slideTo(index)}
              >
                <img
                  src={item.img}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="flex font-pop flex-col gap-2 mt-6">
          <h3
            className={`text-lg font-medium ${
              theme === "dark" ? "text-white" : "text-gray-900"
            }`}
          >
            Description
          </h3>
          <p className={`whitespace-pre-wrap ${
              theme === "dark" ? "text-white" : "text-gray-600"
            }`} >
            {Product?.Description}
          </p>
        </div>

      </div>

      {/* Seller Info Section */}
      <div
        className={`basis-1/3 h-fit rounded-2xl py-4 px-4 border-2 border-light ${
          theme == "dark" ? "bg-black text-white" : "bg-white"
        }`}
      >
        <h3
          className={`border-b-2 border-light text-center py-4 text-lightGrey font-pop ${
            theme == "dark" && "text-white"
          }`}
        >
          Seller info
        </h3>
        <div className="flex flex-col font-pop gap-4 py-4">
          <div className="flex gap-2">
            {User?.ProfilePhoto ? (
              <img
                src={User.ProfilePhoto}
                alt="Profile"
                className="w-12 h-12 rounded-full object-cover"
              />
            ) : (
              <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center">
                <span className="text-gray-600 text-lg">
                  {User?.FirstName?.charAt(0)}
                </span>
              </div>
            )}
            <div className="flex flex-col gap-0">
              <h2 className="text-lg font-medium">
                {User?.FirstName} {User?.LastName}
              </h2>
              <p className="text-lightGrey">
                {Product?.City} {Product?.Country}
              </p>
            </div>
          </div>
          <p
            className={`text-lightGrey text-sm ${
              theme == "dark" && "text-white"
            }`}
          >
            Please call for more information
          </p>
          <div className="flex flex-row gap-2 items-center">
            <button
              className={`bg-primarygreen text-center w-full border-2 border-primarygreen 
                        rounded-full font-pop text-white py-2 px-5 transition-colors
                        hover:bg-primarygreen/90 ${
                          theme == "dark" && "text-white"
                        }`}
              onClick={() => {
                navigate(`/user-dashboard/chat?user=${User._id}`);
              }}
            >
              Message
            </button>
            <button className="border-2 w-fit border-light py-2 px-4 rounded-full hover:bg-gray-50">
              <img
                src="../../../../../../Assets/Prop/Share.png"
                alt="Share"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = `
.product-gallery-swiper {
  border-radius: 8px;
  overflow: hidden;
}

.product-gallery-swiper .swiper-button-next,
.product-gallery-swiper .swiper-button-prev {
  width: 44px;
  height: 44px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  color: #000;
}

.product-gallery-swiper .swiper-button-next:after,
.product-gallery-swiper .swiper-button-prev:after {
  font-size: 20px;
  font-weight: bold;
}

.product-gallery-swiper .swiper-button-next:hover,
.product-gallery-swiper .swiper-button-prev:hover {
  background-color: rgba(255, 255, 255, 1);
}

.dark .product-gallery-swiper .swiper-button-next,
.dark .product-gallery-swiper .swiper-button-prev {
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
}

.dark .product-gallery-swiper .swiper-button-next:hover,
.dark .product-gallery-swiper .swiper-button-prev:hover {
  background-color: rgba(0, 0, 0, 0.9);
}
`;

export default AddDescription;
